import { useEffect, useState } from "react"

export default function useWindowSize() {
	const  [windowSize, setWindowSize] = useState({})
	// useEffect to verify and to show in the correct screen size
	useEffect(() => {
		function handleResize() {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			})
		}
		window.addEventListener("resize", handleResize)
		handleResize()
		return () => window.removeEventListener("resize", handleResize)
	}, [])
	return windowSize
}